import type { CurrentPlatform } from "@/partner/entities/platforms";

export function mapPlatformToBrandingFormValues(
  platform: CurrentPlatform | null | undefined
): Record<string, any> {
  if (!platform) {
    return {
      theme: {
        palette: {
          type: "light",
          primary: "",
          secondary: "",
          backgroundColor: "",
        },
        typography: {
          fontFamily: "",
          headingFontFamily: "",
        },
      },
      logoId: null,
      faviconId: null,
      iconId: null,
      hideableHeader: true,
      isLikesEnabled: true,
      isFavoritesEnabled: true,
      isFeaturedVideosEnabled: true,
      defaultRowSize: 4,
    };
  }

  return {
    theme: {
      palette: {
        type: platform.theme?.palette?.type || "light",
        primary: platform.theme?.palette?.primary || "",
        secondary: platform.theme?.palette?.secondary || "",
        backgroundColor: platform.theme?.palette?.backgroundColor || "",
      },
      typography: {
        fontFamily: platform.theme?.typography?.fontFamily || "",
        headingFontFamily: platform.theme?.typography?.headingFontFamily || "",
      },
    },
    logoId: platform.logoId || null,
    faviconId: platform.faviconId || null,
    iconId: platform.iconId || null,
    hideableHeader: platform.hideableHeader ?? true,
    isLikesEnabled: platform.isLikesEnabled ?? true,
    isFavoritesEnabled: platform.isFavoritesEnabled ?? true,
    isFeaturedVideosEnabled: platform.isFeaturedVideosEnabled ?? true,
    defaultRowSize: platform.defaultRowSize || 4,
  };
}
